<template>
  <div class="purchase-order-material-select hmd-btn">
    <a-button type="primary" @click="showModal">加入材料库</a-button>

    <a-modal
      v-model:visible="visible"
      :keyboard="false"
      :centered="true"
      :mask-closable="false"
      width="90%"
      @ok="ok"
      @cancel="closeModal"
    >
      <template #title>
        <span>加入材料库</span>
        <small>点击确定会将右侧待选列表中的项目加入目标清单</small>
      </template>
      <div>
        <a-row>
          <a-col :span="8">
            <a-form-item>
              <a-input-search
                class="w300"
                placeholder="请输入材料名称关键字"
                enter-button
                @search="onSearch"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-checkbox :checked="checked" @change="onCheckChange"> 使用相同材料分类 </a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>

        <a-table
          row-key="uuid"
          size="small"
          :bordered="true"
          :data-source="dataSource"
          :columns="columns"
          :scroll="{ x: true }"
        >
          <template #index="{ index }">{{ index + 1 }}</template>
          <template #materialCategoryTitle>
            <span class="text-red mr5">*</span>
            <span>所属分类</span>
          </template>
          <template #materialCategoryId="{ record, index }">
            <a-form-item>
              <material-category-select
                :disabled="checked && index > 0"
                class="w100"
                v-model:value="record.materialCategoryId"
                @change="(val) => onCategoryChange(val, index)"
              ></material-category-select>
            </a-form-item>
          </template>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs, watch } from "vue";
import { message } from "ant-design-vue";
import { generateUuid } from "@/utils";
import { columns } from "./constant";
import { MaterialCategorySelect } from "@/components";
import _ from "lodash";

/**
 * 加入材料库材料选择
 */
interface materialObj {
  uuid: string;
  materialNo?: string;
  materialName: string;
  materialModel: string;
  materialBrand: string;
  materialUnit?: string;
  materialCategoryId?: string;
}
export default defineComponent({
  isGlobal: true,
  name: "MaterialLibraryJoinBtn",
  components: { MaterialCategorySelect },
  props: {
    materialList: {
      type: Array as PropType<materialObj[]>,
      default: [
        {
          materialNo: "123456",
          materialName: "防火墙",
          materialModel: "USG6307E",
          materialBrand: "华为",
          materialUnit: "台",
          materialCategoryId: "",
        },
        {
          materialNo: "654321",
          materialName: "精密空调",
          materialModel: "ST017FAACANNT",
          materialBrand: "科士达",
          materialUnit: "台",
          materialCategoryId: "",
        },
      ],
    },
  },
  setup(props, { attrs, slots, emit }) {
    const state = reactive<{
      visible: boolean;
      materialList: materialObj[];
      dataSource: materialObj[];
      checked: boolean;
    }>({
      visible: false,
      materialList: [],
      dataSource: [],
      checked: false,
    });

    const showModal = () => {
      const { materialList } = props;
      state.materialList = _.cloneDeep(materialList).map((item) => {
        item.uuid = generateUuid();
        return item;
      });
      state.dataSource = state.materialList;
      state.visible = true;
    };

    const closeModal = () => {
      state.visible = false;
    };
    const onSearch = (value) => {
      state.dataSource = state.materialList.filter((m) => m.materialName.includes(value));
    };
    const onCheckChange = (e) => {
      state.checked = e.target.checked;
      if (state.checked && state.dataSource[0]?.materialCategoryId) {
        state.dataSource.forEach(
          (d) => (d.materialCategoryId = state.dataSource[0]?.materialCategoryId)
        );
      }
    };

    const onCategoryChange = (val, index) => {
      if (state.checked && !!val && index === 0) {
        state.dataSource.forEach(
          (d) => (d.materialCategoryId = state.dataSource[0]?.materialCategoryId)
        );
      }
    };

    const ok = () => {
      // todo 加入材料库
      // if (ids.length === 0) {
      //   message.warning("请选择材料，加入待选列表");
      //   return;
      // }
      // emit("update:value", ids);
      // emit("change", state.currentMaterialList);
      // closeModal();
    };
    return {
      ...toRefs(state),
      showModal,
      closeModal,
      ok,
      columns,
      onSearch,
      onCheckChange,
      onCategoryChange,
    };
  },
});
</script>

<style lang="less" scoped>
.purchase-order-material-select {
  display: inline-block;
}
</style>

<style lang="less">
.purchase-order-material-select__modal {
  position: relative;
  padding: 0 415px 0 0;
  min-height: 500px;

  &__right {
    position: absolute;
    top: 0;
    height: 100%;
    overflow-y: auto;
  }

  &__right {
    right: 0;
    width: 400px;
  }
}
</style>
